module.exports = __webpack_public_path__ + "img/footer-icon-instagram.b59c74c3.png";